import React from "react";
import ReactDOM from "react-dom";

/**
 * @param {string} entrypoint Basename of the entrypoint i.e. "entrypoint" for `client/entries/entrypoint.js`
 * @param exported - hash list of elements to pass to the renderer
 *
 * @returns {Promise<void>[]}
 */
const renderer = (entrypoint, exported = {}) => {
  const elements = document.querySelectorAll(
    `[data-se-entry=${entrypoint}]:not([data-se-rendered])`
  );

  return Array.from(elements).map(async e => {
    const [component, props] = window[e.dataset.seId];
    const module = await exported[component];
    if (module) {
      const Component = module.__esModule ? module.default : module;
      const componentProps = {
        entrypoint,
        ...props
      };
      ReactDOM.render(<Component {...componentProps} />, e);
      // this makes sure that the component won't be remounted to the same place again
      e.setAttribute("data-se-rendered", "true");
    } else {
      /* eslint-disable-next-line no-console */
      console.error("se_embed_react() requested component not exported.", {
        entrypoint,
        component,
        props,
        exported
      });
    }
  });
};

export default renderer;
